<template>
  <div class="legals-filters">
    <e-input v-model="filters.searchString" label="Поиск" class="legals-filters__search">
      <template #append-inner>
        <e-icon name="search" size="20" />
      </template>
    </e-input>
  </div>
</template>

<script setup lang="ts">
import { EIcon, EInput } from '@/core/components/ui';

const filters = defineModel<{
  searchString: string;
}>({ required: true });
</script>

<style scoped lang="scss">
.legals-filters {
  width: 100%;

  &__search {
    @include md-and-up {
      max-width: 280px;
    }
  }
}
</style>
